import type { FunctionComponent } from 'preact';
import { createContext } from 'preact';
import type { IEnhancementService } from './service.interface';

/**
 * Context for providing the enhancement service throughout the component tree
 */
export const EnhancementServiceContext = createContext<IEnhancementService | null>(null);

interface EnhancementServiceProviderProps {
  enhancementService: IEnhancementService;
}

/**
 * Provider component that makes the enhancement service available to all child components
 *
 * This provider is added to the provider composition in the Ground Control initialization
 * and allows components to access the enhancement service via useEnhancementService hook
 *
 * @example
 * <EnhancementServiceProvider enhancementService={enhancementService}>
 *   <App />
 * </EnhancementServiceProvider>
 */
export const EnhancementServiceProvider: FunctionComponent<EnhancementServiceProviderProps> = ({
  enhancementService,
  children
}) => {
  return <EnhancementServiceContext.Provider value={enhancementService}>{children}</EnhancementServiceContext.Provider>;
};
